import React from "react";
import logo from "../images/logoForLightTheme.png";
import "./hm-theme.css";

function Privacypolicy() {
  return (
    <div className="hm-page-wrapper container-fluid px-3 py-4">
      <div className="hm-card max-width-1100 mx-auto">
        {/* Header Banner */}
        <div className="hm-card-header d-flex align-items-center justify-content-between flex-wrap gap-3 py-3 px-4" style={{ background: "linear-gradient(135deg, #2f3a88 0%, #2cb6e9 100%)", borderRadius: "18px 18px 0 0" }}>
          <div className="d-flex align-items-center gap-3">
            <div className="bg-white p-2 rounded-3 d-flex align-items-center justify-content-center" style={{ height: "48px" }}>
              <img
                src={logo}
                alt="HealrMed Logo"
                style={{ height: "36px", objectFit: "contain" }}
              />
            </div>
            <div>
              <h3 className="text-white fw-bold mb-0" style={{ fontSize: "1.35rem" }}>
                Privacy Policy
              </h3>
              <p className="text-white-50 mb-0 small">Timespan Management Private Limited</p>
            </div>
          </div>
        </div>

        {/* Content Body */}
        <div className="hm-card-body p-4 p-md-5">
          <section className="mb-4">
            <h5 className="fw-bold text-primary mb-2">1. INTRODUCTION</h5>
            <p className="text-secondary lh-base">
              Timespan Management Private Limited ("Company", "we", "us", "our") respects the privacy of our
              users ("user", "you", "your"). This Privacy Policy explains how we collect, use, disclose,
              and safeguard your information when you visit our website or use our services.
            </p>
          </section>

          <section className="mb-4">
            <h5 className="fw-bold text-primary mb-2">2. DATA COLLECTION</h5>
            <p className="text-secondary lh-base mb-2">We may collect and process the following data about you:</p>
            <ul className="text-secondary lh-base ps-3">
              <li className="mb-2">
                <strong className="text-dark">Identity and Contact Data:</strong> Includes data relating to your
                identity such as your first name, last name, username, title, billing address, delivery address,
                email address, and telephone numbers.
              </li>
              <li className="mb-2">
                <strong className="text-dark">Technical Data:</strong> Includes geolocation data, IP address,
                login data, device type, internet service provider, operating system, browser type, pages viewed,
                and time/date of visit.
              </li>
              <li className="mb-2">
                <strong className="text-dark">Usage Data:</strong> Details of your usage of our website, products, and
                services, including traffic data, logs, communication resources, and response to marketing.
              </li>
              <li className="mb-2">
                <strong className="text-dark">Marketing and Communications Data:</strong> Your preferences in receiving
                marketing from us and third parties, and communication preferences.
              </li>
            </ul>
          </section>

          <section className="mb-4">
            <h5 className="fw-bold text-primary mb-2">3. USE OF YOUR INFORMATION</h5>
            <p className="text-secondary lh-base mb-2">We use the collected data for various purposes:</p>
            <ul className="text-secondary lh-base ps-3">
              <li className="mb-1">To maintain and improve our website and services</li>
              <li className="mb-1">To manage your account and provide customer support</li>
              <li className="mb-1">To perform research and analysis about your use of our services</li>
              <li className="mb-1">To develop and display content and advertising tailored to your interests</li>
              <li className="mb-1">To verify your eligibility and deliver prizes for contests</li>
              <li className="mb-1">To enforce our terms and conditions and manage business operations</li>
            </ul>
          </section>

          <section className="mb-4">
            <h5 className="fw-bold text-primary mb-2">4. DATA DISCLOSURE</h5>
            <p className="text-secondary lh-base">
              We do not share your personal information with others except as indicated within this policy
              or when we inform you and give you an opportunity to opt-out of having your personal information shared.
            </p>
          </section>

          <section className="mb-4">
            <h5 className="fw-bold text-primary mb-2">5. DATA SECURITY</h5>
            <p className="text-secondary lh-base">
              We have implemented measures designed to secure your personal information from accidental loss
              and from unauthorized access, use, alteration, and disclosure.
            </p>
          </section>

          <section className="mb-4">
            <h5 className="fw-bold text-primary mb-2">6. DATA RETENTION</h5>
            <p className="text-secondary lh-base">
              We retain personal information for as long as necessary to fulfill the purposes for which you
              provided it, comply with our legal obligations, resolve disputes, and enforce our agreements and policies.
            </p>
          </section>

          <section className="mb-4">
            <h5 className="fw-bold text-primary mb-2">7. YOUR RIGHTS</h5>
            <p className="text-secondary lh-base mb-2">
              Under data protection laws, you have a number of important rights, including:
            </p>
            <ul className="text-secondary lh-base ps-3">
              <li className="mb-1">Fair processing of information and transparency over personal info usage</li>
              <li className="mb-1">Access to your personal information</li>
              <li className="mb-1">Require us to correct any mistakes in your information</li>
              <li className="mb-1">Require deletion of personal information concerning you in certain situations</li>
              <li className="mb-1">Receive personal information in a structured, machine-readable format</li>
              <li className="mb-1">Object at any time to processing for direct marketing</li>
              <li className="mb-1">Object to decisions taken by automated means with legal effects</li>
              <li className="mb-1">Object in certain situations to continued processing of your personal information</li>
            </ul>
          </section>

          <section className="mb-4">
            <h5 className="fw-bold text-primary mb-2">8. CHANGES TO THE POLICY</h5>
            <p className="text-secondary lh-base">
              We will post any changes we make to our privacy policy on this page and, if significant,
              we will notify you by sending an email.
            </p>
          </section>

          <section className="mb-2">
            <h5 className="fw-bold text-primary mb-2">9. CONTACT US</h5>
            <p className="text-secondary lh-base mb-0">
              Should you have any queries regarding this Privacy Policy, please contact Timespan's Data Protection Officer at:{" "}
              <a href="mailto:info@timespan.in" className="text-primary fw-semibold">
                info@timespan.in
              </a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default Privacypolicy;

